import Axios from "axios";
import {
    SET_PUR_REQUSITION_MERGE_LIST,
    UNSET_PUR_REQUSITION_MERGE_LIST,
    SET_RFQABLE_PUR_REQUSITION_MERGE_LIST,
    UNSET_RFQABLE_PUR_REQUSITION_MERGE_LIST,
    SET_ORDERABLE_PUR_REQUSITION_MERGE_LIST,
    UNSET_ORDERABLE_PUR_REQUSITION_MERGE_LIST,
  } from "@/store/mutation-types";
import {
  saveUpdatePurRequisitionMerge,
  getPurRequisitionMergeList,
  getPurRequisitionMergeById,
  getRfqablePurRequisitionMergeList,
  getOrderablePurRequisitionMergeList
} from "@/store/api";
// initial state
const state = {
  getPurRequisitionMergeList: [],
  editingRequisition: null,
  getRfqablePurRequisitionMergeList: [],
  getOrderablePurRequisitionMergeList: [],
};
  

const getters = {
  getPurRequisitionMergeList(state) {
    return state.getPurRequisitionMergeList;
  },
  getRfqablePurRequisitionMergeList(state) {
    return state.getRfqablePurRequisitionMergeList;
  },
  getOrderablePurRequisitionMergeList(state){
    return state.getOrderablePurRequisitionMergeList;
  }
};

const mutations = {
  [SET_PUR_REQUSITION_MERGE_LIST](state, data) {
    state.getPurRequisitionMergeList = data;
  },
  [UNSET_PUR_REQUSITION_MERGE_LIST](state) {
    state.getPurRequisitionMergeList = [];
  },
  [SET_RFQABLE_PUR_REQUSITION_MERGE_LIST](state, data) {
    state.getRfqablePurRequisitionMergeList = data;
  },
  [UNSET_RFQABLE_PUR_REQUSITION_MERGE_LIST](state) {
    state.getRfqablePurRequisitionMergeList = [];
  },
  [SET_ORDERABLE_PUR_REQUSITION_MERGE_LIST](state, data) {
    state.getOrderablePurRequisitionMergeList = data;
  },
  [UNSET_ORDERABLE_PUR_REQUSITION_MERGE_LIST](state) {
    state.getOrderablePurRequisitionMergeList = [];
  },
  setEditingRequisition(state, requisition) {
    state.editingRequisition = requisition;
  },
};

const actions = {
  getOrderablePurRequisitionMergeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getOrderablePurRequisitionMergeList, data)
        .then(function (response) {
          commit('SET_ORDERABLE_PUR_REQUSITION_MERGE_LIST', response.data.data);
          console.log(response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_ORDERABLE_PUR_REQUSITION_MERGE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  getRfqablePurRequisitionMergeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getRfqablePurRequisitionMergeList, data)
        .then(function (response) {
          commit('SET_RFQABLE_PUR_REQUSITION_MERGE_LIST', response.data.data);
          console.log(response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_RFQABLE_PUR_REQUSITION_MERGE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
  saveUpdatePurRequisitionMerge({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePurRequisitionMerge, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getPurRequisitionMergeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPurRequisitionMergeList, data)
        .then(function (response) {
          commit('SET_PUR_REQUSITION_MERGE_LIST', response.data.data);
          console.log(response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PUR_REQUSITION_MERGE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getPurRequisitionMergeById({ commit }, id) {
    const getPurRequisitionMergeByApiId = `${getPurRequisitionMergeById}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(getPurRequisitionMergeByApiId)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always)=> {
          commit("UNSET_LOADING");
        });
    });
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
